// Path: src/Screens/admin/CategoryManagement/CategoryManagement.jsx
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AppContext from "../../../context/AppContext.js";
import MasterLayout from "../../../layout/superadmin/MasterLayout";
import {
  FiPlus,
  FiMoreVertical,
  FiTrash2,
  FiEdit2,
  FiToggleLeft,
  FiToggleRight,
} from "react-icons/fi";
import Swal from "sweetalert2";
import { BsImage } from "react-icons/bs";
import AppPagination from "../../../components/general/pagination/Pagination.js";
import "../../../assets/css/superadmin/categorymanagment/CategoryManagment.css";

// ── Database mein "self_powered" / "implement" save hota hai.
// Table mein saaf/parhne layak lafzon mein dikhane ke liye ye chota
// helper function hai. ──
function formatEquipmentType(type) {
  if (type === "implement") return "Implement";
  return "Self-Powered";
}

const CategoryManagement = () => {
  const { baseUrl, baseUrlForFile , authToken} = useContext(AppContext);
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [idToUpdateDeleteCategory, setIDToUpdateDeleteCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryImagePreview, setCategoryImagePreview] = useState(null);
  const [categorystatus, setCategoryStatus] = useState(true);
  const [equipmentType, setEquipmentType] = useState("self_powered");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMenu, setActiveMenu] = useState(null);
  const [editingCategory, setEditingCategory] = useState(false);

  const categoriesPerPage = 4;

const addCategory = () => {
  if (!name.trim() || !image) {
    Swal.fire({
      icon: "warning",
      title: "Oops!",
      text: "Please enter your data",
      confirmButtonText: "OK",
      confirmButtonColor: "#7c3aed",
    });
    return;
  }

  const formData = new FormData();
  formData.append("name", name);
  formData.append("equipment_type", equipmentType);
  formData.append("image", image);

  axios
    .post(`${baseUrl}/superadmin/category/addCategory`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${authToken}`
      },
    })
    .then((response) => {
      console.log(response.data);
      viewAllCategories();
      resetForm();

      Swal.fire({
        icon: "success",
        title: "Congratulations!",
        text: "Category Added successfully",
        confirmButtonText: "Wow",
        confirmButtonColor: "#7c3aed",
      });
    })
    .catch((error) => {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong, please try again",
        confirmButtonColor: "#7c3aed",
      });
    });
};
  const updateCategory = () => {
    const formData = new FormData();
    formData.append("id", idToUpdateDeleteCategory);
    formData.append("name", name);
    formData.append("equipment_type", equipmentType);
    formData.append("image", image);
    axios
      .post(`${baseUrl}/superadmin/category/updateCategory`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllCategories();
        resetForm();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllCategories = () => {
    axios
      .get(`${baseUrl}/superadmin/category/viewAllCategories`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data.success && response.data.data) {
          setCategories(response.data.data);
        } else {
          setCategories([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setCategories([]);
      });
  };

  useEffect(() => {
    viewAllCategories();
  }, []);

  const deleteCategory = (id) => {
    console.log("********");
    console.log(id);
    console.log("****");
    const formData = new FormData();
    formData.append("id", id);
    axios
      .post(`${baseUrl}/superadmin/category/deleteCategory`, formData, {
        headers: {
          "Content-Type": "multipart/form-Data",
          Authorization: `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllCategories();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleMenu = (id) => {
    setActiveMenu(activeMenu === id ? null : id);
  };

  const handleToggleStatus = (id, isCurrentlyActive) => {
    console.log("Toggle ID:", id);
    console.log("isCurrentlyActive:", isCurrentlyActive);
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", isCurrentlyActive ? "inactive" : "active");
    axios
      .post(`${baseUrl}/superadmin/category/updateCategory`, formData, {
        headers: { "Content-Type": "multipart/form-data" ,
          Authorization: `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log("Toggle response:", response.data);
        viewAllCategories();
      })
      .catch((error) => {
        console.log("Toggle error:", error);
      });
  };

  const handleEdit = (category) => {
    setEditingCategory(true);
    setIDToUpdateDeleteCategory(category.id);
    setName(category.name);
    setEquipmentType(category.equipment_type || "self_powered");
    setCategoryImagePreview(
      category.image ? `${baseUrlForFile}/${category.image}` : null,
    );
    setImage(null);
    setActiveMenu(null);
  };

  const resetForm = () => {
    setEditingCategory(false);
    setIDToUpdateDeleteCategory("");
    setName("");
    setEquipmentType("self_powered");
    setImage(null);
    setCategoryImagePreview(null);
  };

  // Pagination Logic
  const indexOfLastCategory = currentPage * categoriesPerPage;
  const indexOfFirstCategory = indexOfLastCategory - categoriesPerPage;
  const currentCategories = categories.slice(
    indexOfFirstCategory,
    indexOfLastCategory,
  );
  const totalPages = Math.ceil(categories.length / categoriesPerPage);

  return (
    <MasterLayout>
      <div className="catmgmt-category-management-page">
        <div className="catmgmt-category-container">
          {/* Add New Category Section */}
          <div className="catmgmt-add-category-section">
            <div className="catmgmt-section-header">
              <FiPlus className="catmgmt-header-icon" />
              <h2 className="catmgmt-section-title">
                {editingCategory ? "Edit Category" : "Add New Category"}
              </h2>
            </div>

            <div className="catmgmt-add-category-form">
              {/* Image Upload */}
              <div className="catmgmt-form-group">
                <label className="catmgmt-form-label">Category Image</label>
                <div className="catmgmt-image-upload-wrapper">
                  <input
                    type="file"
                    id="categoryImage"
                    accept="image/*"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      setImage(file);
                      setCategoryImagePreview(URL.createObjectURL(file));
                    }}
                    className="catmgmt-image-input-hidden"
                  />
                  <label
                    htmlFor="categoryImage"
                    className="catmgmt-image-upload-box"
                  >
                    {categoryImagePreview ? (
                      <img
                        src={categoryImagePreview}
                        alt="Preview"
                        className="catmgmt-image-preview"
                      />
                    ) : (
                      <div className="catmgmt-upload-placeholder">
                        <BsImage className="catmgmt-upload-icon" />
                        <span className="catmgmt-upload-text">UPLOAD</span>
                      </div>
                    )}
                  </label>
                </div>
              </div>

              {/* Category Name Input */}
              <div className="catmgmt-form-group">
                <label className="catmgmt-form-label">Category Name</label>
                <input
                  type="text"
                  className="catmgmt-category-input"
                  placeholder="e.g. Heavy-Duty Tractors"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </div>

              {/* Equipment Type — self-powered (khud engine hai) ya implement
                  (tractor ke peeche lagta hai, akela chal nahi sakta) */}
              <div className="catmgmt-form-group">
                <label className="catmgmt-form-label">Equipment Type</label>
                <select
                  className="catmgmt-category-input"
                  value={equipmentType}
                  onChange={(event) => setEquipmentType(event.target.value)}
                >
                  <option value="self_powered">
                    Self-Powered (has its own engine — e.g. Tractor, Harvester)
                  </option>
                  <option value="implement">
                    Implement (needs a tractor to operate — e.g. Rotavator, Disc Harrow)
                  </option>
                </select>
                <small style={{ color: "#999", fontSize: "0.8rem" }}>
                  "Implement" categories will remind rental admins to include
                  tractor, driver and diesel in their pricing.
                </small>
              </div>

              {/* Add/Update Buttons */}
              <div className="catmgmt-button-group">
                {editingCategory && (
                  <button className="catmgmt-cancel-btn" onClick={resetForm}>
                    Cancel
                  </button>
                )}
                <button
                  className="catmgmt-add-category-btn"
                  onClick={editingCategory ? updateCategory : addCategory}
                >
                  <FiPlus size={20} />
                  {editingCategory ? "Update Category" : "Add Category"}
                </button>
              </div>
            </div>
          </div>

          {/* Existing Categories Section */}
          <div className="catmgmt-existing-categories-section">
            <div className="catmgmt-categories-header">
              <h3 className="catmgmt-categories-title">Existing Categories</h3>
            </div>

            {/* Categories Table */}
            <div className="catmgmt-categories-table-wrapper">
              <table className="catmgmt-categories-table">
                <thead>
                  <tr>
                    <th>CATEGORY ID</th>
                    <th>IMAGE</th>
                    <th>NAME</th>
                    {/* ← NAYA COLUMN HEADER */}
                    <th>EQUIPMENT TYPE</th>
                    <th>STATUS</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCategories.map((category) => {
                    // ✅ FIX: database column "status" = 'active' string
                    const isActive = category.status === "active";
                    return (
                      <tr key={category.id}>
                        <td className="catmgmt-category-id">#{category.id}</td>
                        <td>
                          <img
                            src={`${baseUrlForFile}/${category.image}`}
                            alt={category.name}
                            className="catmgmt-category-table-image"
                          />
                        </td>
                        <td className="catmgmt-category-name">
                          {category.name}
                        </td>
                        {/* ← NAYA COLUMN DATA: self_powered/implement ko
                            saaf lafzon mein dikhata hai */}
                        <td>{formatEquipmentType(category.equipment_type)}</td>
                        <td>
                          <span
                            className={`catmgmt-status-badge ${isActive ? "active" : "disabled"}`}
                          >
                            {isActive ? "Active" : "Disabled"}
                          </span>
                        </td>
                        <td className="catmgmt-category-actions">
                          <div className="catmgmt-actions-menu-wrapper">
                            <button
                              className="catmgmt-menu-button"
                              onClick={() => toggleMenu(category.id)}
                            >
                              <FiMoreVertical size={20} />
                            </button>
                            {activeMenu === category.id && (
                              <div className="catmgmt-dropdown-menu">
                                <button
                                  className="catmgmt-edit-option"
                                  onClick={() => handleEdit(category)}
                                >
                                  <FiEdit2 size={16} />
                                  Edit
                                </button>
                                <button
                                  className="catmgmt-toggle-option"
                                  onClick={() => {
                                    handleToggleStatus(category.id, isActive);
                                    setActiveMenu(null);
                                  }}
                                >
                                  {isActive ? (
                                    <>
                                      <FiToggleLeft size={16} />
                                      Disable
                                    </>
                                  ) : (
                                    <>
                                      <FiToggleRight size={16} />
                                      Enable
                                    </>
                                  )}
                                </button>
                                <button
                                  className="catmgmt-delete-option"
                                  onClick={() => deleteCategory(category.id)}
                                >
                                  <FiTrash2 size={16} />
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <AppPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={categories.length}
              itemsPerPage={categoriesPerPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default CategoryManagement;